var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex":"1"}},[_c('label',{staticClass:"version"},[_vm._v(_vm._s(_vm.version))]),_c('label',{staticClass:"banner",staticStyle:{"text-align":"center","flex":"1"}},[_vm._v(_vm._s(_vm.environmentBannerLabel))]),_c('label',{staticClass:"mb-0 wapVersion"},[_vm._v(" "+_vm._s(_vm.wapVersion)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }